/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '~/lib/api/axiosClient';
import type {
  ConcluirFluxoCompromissoAvulsoMutationRequest,
  ConcluirFluxoCompromissoAvulsoMutationResponse,
  ConcluirFluxoCompromissoAvulso401,
} from '../../types/ConcluirFluxoCompromissoAvulso.ts';
import type { RequestConfig, ResponseErrorConfig } from '~/lib/api/axiosClient';

function getConcluirFluxoCompromissoAvulsoUrl() {
  const res = {
    method: 'POST',
    url: `/compromisso-avulso/concluir-fluxo` as const,
  };
  return res;
}

/**
 * @description Conclui fluxos de compromissos avulsos
 * @summary Concluir fluxo compromisso avulso
 * {@link /compromisso-avulso/concluir-fluxo}
 */
export async function concluirFluxoCompromissoAvulso(
  data?: ConcluirFluxoCompromissoAvulsoMutationRequest,
  config: Partial<
    RequestConfig<ConcluirFluxoCompromissoAvulsoMutationRequest>
  > & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    ConcluirFluxoCompromissoAvulsoMutationResponse,
    ResponseErrorConfig<ConcluirFluxoCompromissoAvulso401>,
    ConcluirFluxoCompromissoAvulsoMutationRequest
  >({
    method: 'POST',
    url: getConcluirFluxoCompromissoAvulsoUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
